import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function WorkerJobsLoading() {
  return (
    <div className="min-h-screen bg-background pb-20">
      <div className="mx-auto max-w-screen-sm px-4 py-4 space-y-4">
        {/* Trade filter pills skeleton */}
        <div className="flex gap-2 overflow-hidden">
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} className="h-12 w-24 shrink-0 rounded-full" />
          ))}
        </div>

        {/* Hint text skeleton */}
        <Skeleton className="h-4 w-64 mx-auto" />

        {/* Job cards skeleton */}
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-5 space-y-3">
              <div className="flex items-center gap-2">
                <Skeleton className="h-7 w-24 rounded-full" />
              </div>
              <Skeleton className="h-6 w-3/4" />
              <div className="flex gap-4 mt-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-4 w-20" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
